import React from 'react'
import { G, Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChannelMailIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <G transform='translate(2.4, 2.5) scale(0.8)'>
            <Path
                d='M3 7V18H21V7H3ZM3 5H21C21.5304 5 22.0391 5.21071 22.4142 5.58579C22.7893 5.96086 23 6.46957 23 7V18C23 18.5304 22.7893 19.0391 22.4142 19.4142C22.0391 19.7893 21.5304 20 21 20H3C2.46957 20 1.96086 19.7893 1.58579 19.4142C1.21071 19.0391 1 18.5304 1 18V7C1 6.46957 1.21071 5.96086 1.58579 5.58579C1.96086 5.21071 2.46957 5 3 5Z'
                fill='currentColor'
            />
            <Path
                d='M3.944 6.264L12 11.746L20.056 6.264H3.944ZM3.049 5.14L11.105 5.354H20.951C21.939 5.848 22.339 6.172 21.845 7.16C21.6921 7.46556 21.4635 7.72687 21.181 7.919L13.125 13.4C12.7932 13.6257 12.4013 13.7464 12 13.7464C11.5987 13.7464 11.2068 13.6257 10.875 13.4L2.82 7.918C1.906 7.296 2.745 5.292 3.05 5.139L3.049 5.14Z'
                fill='currentColor'
            />
        </G>
    ),
})

ChannelMailIcon.displayName = 'ChannelMailIcon'
